/* eslint-disable @typescript-eslint/no-explicit-any */
import { BlueprintData8, BlueprintKitchenData7 } from '../../types';

export const updateKitchens = (kitchens: BlueprintKitchenData7[]) => {
	const updatedKitchens = kitchens.map((kitchen: BlueprintKitchenData7) => {
		const accessories = (kitchen as any).accessories ? (kitchen as any).accessories : null;
		console.log('kitche:v7', kitchen);
		return {
			...kitchen,
			accessories,
			design: {
				...kitchen.design,
				countertops: {
					children: kitchen.design.countertops.map((countertop) => {
						return countertop;
					}) ?? []
				},
				obstructions: (kitchen.design as any).obstructions ?? {
					defaultIslandId: null,
					children: []
				},
				islands: {
					...kitchen.design.islands,
					children: kitchen.design.islands.children.map((island) => {
						return {
							...island,
							connections: {
								children: island.connections.map((connection) => {
									return connection;
								}) ?? []
							},
							trims: {
								children: island.trims.map((panelTrim) => {
									return panelTrim;
								}) ?? []
							},
							panels: {
								...island.panels,
								children: island.panels.children.map((panel) => {
									return {
										...panel,
										breakpoints: {
											...panel.breakpoints,
											children: panel.breakpoints.children?.map((breakpoint) => {
												return breakpoint;
											}) ?? []
										},
										panelItemGroups: {
											...panel.panelItemGroups,
											children: panel.panelItemGroups?.map((panelItemGroup) => {
												return {
													...panelItemGroup,
													items: {
														...panelItemGroup.items,
														children: panelItemGroup.items?.map((item) => {
															// const newY = item.center.y - (island.size.height / 2);
															// let newZ: number | null = null;

															// if (item.center.z !== null) {
															// 	const depth = isNaN(island.size.depth) ? island.size.depth.left : island.size.depth;
															// 	newZ = nearestSixteenth(item.center.z - ((depth ?? 0) / 2) + ((panel.metadata?.size?.depth ?? 0) / 2));
															// }
															// console.log('update:item', item.size, item.center.y, newY);
															// console.log('update:item', item.size, item.center.z, newZ);
															// item.center.z = newZ;
															// item.center.y = newY;
															return item;
														}) ?? []
													}
												};
											}) ?? []
										}
									};
								}) ?? []
							}
						};
					})
				}
			}
		};
	});


	return {
		children: updatedKitchens
	} as BlueprintData8['kitchens'];
};
